import React from "react";
import PayoutsList from "../components/PayoutsList";

const Payouts = () => {
  return <PayoutsList />;
};

export default Payouts;
